export default __webpack_public_path__ + "static/media/Banner 2.1ae37841.jpg";